export default {
    values: {
        'Back To': 'Voltar Para',
        Showing: 'Mostrando',
        Results: 'Resultados',
        'Remove filters': 'Remover filtros',
        'Download list': 'Download da lista',
        selected_label: 'selecionados',
        'Select a vehicle': 'Selecione o veículo',
        'Please select a vehicle': 'Por favor selecione um veículo',
        'to load information in this section.': 'Para carregar informações nesta seção',
        'Empty options': 'Nenhuma opção encontrada'
    }
}
